import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { updatePasswordApi } from 'api/services/authentication';
import { toast, Bounce } from "react-toastify";
import { Button } from 'components/Button';
const schema = yup.object().shape({
  newPassword: yup
    .string()
    .required('New password is required')
    .min(8, 'Password must be at least 8 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
      'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
    ),
  confirmPassword: yup
    .string()
    .required('Confirm password is required')
    .oneOf([yup.ref('newPassword')], 'Passwords must match')
});

const ResetPassword = () => {
  const [isResetSuccessful, setIsResetSuccessful] = useState(false);
  const [error, setError] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });

  const onSubmit = async (data) => {
    try {
      // Here you would make an API call to reset the password
      // Example:
    updatePasswordApi({password:data.newPassword}).then((res) => {
      console.log(res)
      console.log('Password reset data:', data);
      setIsResetSuccessful(true);
      toast.success( "Password updated successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
      
    }).catch((err) => {
        toast.error(err.response.data.message || "Failed to reset password. Please try again.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      console.log(err)
    })
      
    
    } catch (err) {
       
    }
  };

  return (
    <div className="container d-flex   min-vh-100  ">
      <div className="card shadow-sm" style={{ maxWidth: '500px', width: '100%' }}>
        <div className="card-header bg-white">
          <h3 className="mb-0">Reset Password</h3>
        </div>
        <div className="card-body">
          {isResetSuccessful ? (
            <div className="alert alert-success" role="alert">
              Your password has been reset successfully!
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)}>
              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}
              
              <div className="mb-3">
                <label htmlFor="newPassword" className="form-label">New Password</label>
                <input
                  type="password"
                  className={`form-control ${errors.newPassword ? 'is-invalid' : ''}`}
                  id="newPassword"
                  {...register('newPassword')}
                />
                {errors.newPassword && (
                  <div className="invalid-feedback">
                    {errors.newPassword.message}
                  </div>
                )}
              </div>
              
              <div className="mb-3">
                <label htmlFor="confirmPassword" className="form-label">Confirm New Password</label>
                <input
                  type="password"
                  className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                  id="confirmPassword"
                  {...register('confirmPassword')}
                />
                {errors.confirmPassword && (
                  <div className="invalid-feedback">
                    {errors.confirmPassword.message}
                  </div>
                )}
              </div>
              
              <button type="submit" className="btn btn-primary w-100">
                Reset Password
              </button>
            </form>
          )}
        </div>
        {/* {isResetSuccessful && (
          <div className="card-footer bg-white">
            <Button
            label="Return to Login"
            className="btn btn-primary w-100"
            onClick={() => {
             
            }}
            >
              Return to Login
            </Button>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default ResetPassword;
